module.exports = __webpack_public_path__ + "static/media/ICONMarker.d9bb47e1.png";